import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../api/axiosBaseQuery";

export const userreportAPI = createApi({
  reducerPath: "userreportAPI",
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    
    fetchReportVersion: builder.query({
      query: (employeeId) => ({
        url: `/report/reports/${employeeId}/versions`,
        method: 'GET'
      }),
    }),
    // fetchEmployeeProfile: builder.mutation({
    //     query: (employeeId) => ({
    //       url: `/profile/employee/profile/${employeeId}`,
    //       method: 'GET'
    //     }),
    //   }),
    fetchComments: builder.query({
        query: (employeeId) => ({
          url: `/comment/comments/${employeeId}`,
          method: 'GET'
        }),
      }),
      updateComments: builder.mutation({
        query: ({ user_id,report_version_id, ...rest }) => ({
          url: `/comment/new/comments/${user_id}/${report_version_id}`,
          method: "PUT",
          data: rest,
        }),
      }),
      
      addComments: builder.mutation({
        query: (data) => ({
          url: "/comment/comments/",
          method: "POST",
          data,
        }),
      }),
      fetchReportHistory: builder.query({
        query: (employeeId) => ({
          url: `history/report_history/${employeeId}/versions`,
          method: "GET",
          
        }),
      }),
      


    
    
    
  }),
});

// Export hooks for usage in functional components
export const {
  useFetchReportVersionQuery,
  useFetchCommentsQuery,
  useUpdateCommentsMutation,
  useAddCommentsMutation,
  useFetchReportHistoryQuery
  

} = userreportAPI;

export default userreportAPI;